import { mergeAttributes, Node, nodeInputRule } from '@tiptap/core';

export interface ImageOptions {
	inline: boolean;
	allowBase64: boolean;
	HTMLAttributes: Record<string, unknown>;
}

export const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

export const Image = Node.create<ImageOptions>({
	name: 'image',

	addOptions() {
		return {
			inline: false,
			allowBase64: false,
			HTMLAttributes: {},
		};
	},

	inline() {
		return this.options.inline;
	},

	group() {
		return this.options.inline ? 'inline' : 'block';
	},

	draggable: true,

	addAttributes() {
		return {
			src: {
				default: null,
			},
			alt: {
				default: null,
			},
			title: {
				default: null,
			},
			'data-fileId': {
				default: null,
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: this.options.allowBase64 ? 'img[src]' : 'img[src]:not([src^="data:"])',
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
	},

	addCommands() {
		return {
			setImage:
				(options) =>
				({ commands }) =>
					commands.insertContent({
						type: this.name,
						attrs: options,
					}),
		};
	},

	addInputRules() {
		return [
			nodeInputRule({
				find: inputRegex,
				type: this.type,
				getAttributes: (match) => {
					const [, , alt, src, title] = match;

					return { src, alt, title };
				},
			}),
		];
	},
});

// TODO: Use dropzone
// export interface HandleImageDropOptions {
// 	event: DragEvent;
// 	onLoadCallback?: (file: File) => Promise<void>;
// }

// export const handleImageDrop = (options: HandleImageDropOptions) => {
// 	const { event, onLoadCallback } = options;
// 	if (!event?.dataTransfer?.files?.[0]) {
// 		return;
// 	}
// 	const file = event.dataTransfer.files[0];
// 	const filesize = (file.size / 1024 / 1024).toFixed(4);
// 	if ((file.type === 'image/jpeg' || file.type === 'image/png') && +filesize < 10) {
// 		const _URL = window.URL || window.webkitURL;
// 		const img = new Image();
// 		img.src = _URL.createObjectURL(file);
// 		// eslint-disable-next-line func-names
// 		img.onload = function () {
// 			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// 			// @ts-ignore
// 			if (this.width > 5000 || this.height > 5000) {
// 				return;
// 			}

// 			// TODO
// 			// eslint-disable-next-line no-console
// 			onLoadCallback?.(file).catch(console.error);
// 		};
// 	} else {
// 		// TODO: notificator
// 		// eslint-disable-next-line no-alert
// 		window.alert('Images need to be in jpg or png format and less than 10mb in size.');
// 	}
// };
